import { extractYouTubeId } from '@/utils/youtube';
import { StructuredText, Image } from 'react-datocms';
import { YouTubeEmbed } from '@next/third-parties/google';
import type { PageHeroFragment } from '@/utils/dato/generated';
import { isEmptyDocument, type Document } from 'datocms-structured-text-utils';
import {
  listItemIconRule,
  customNodeRules,
  paragraphRule,
  renderBlock,
  headingRule,
  listRule,
} from '@/components/structuredText';

const PageHero = ({ pageHeroPrimaryContent, secondaryContent, youtubeUrl, image }: PageHeroFragment) => (
  <div className="container pt-4 lg:pt-10 pb-8 lg:pb-11">
    <div className="clearfix">
      <div className="block display-heading lead">
        {image?.responsiveImage || youtubeUrl ? (
          <div
            className="px-4 md:float-right relative z-[2] md:w-[45%] hidden md:block max-w-[500px] md:max-w-full
          mx-auto md:mx-0"
          >
            {(() => {
              const videoId = youtubeUrl ? extractYouTubeId(youtubeUrl) : null;
              if (videoId) {
                return <YouTubeEmbed style="width:100%" videoid={videoId} />;
              }
              if (image?.responsiveImage) {
                return <Image data={image.responsiveImage} priority={true} />;
              }
              return null;
            })()}
          </div>
        ) : null}
        <div className="px-4 relative z-[2] md:w-[55%]">
          <StructuredText
            data={{ value: pageHeroPrimaryContent?.value as Document, blocks: pageHeroPrimaryContent?.blocks }}
            customNodeRules={[paragraphRule, headingRule, listRule, listItemIconRule('check')]}
            renderBlock={renderBlock}
          />
        </div>
      </div>

      {!isEmptyDocument(secondaryContent?.value) ? (
        <div className="w-full md:w-[55%] md:float-left mt-5 md:mt-11 relative">
          <div
            className="absolute inset-y-0 left-[-999px] w-[9999px] bg-base-100 -z-10 md:left-[-30px]
            md:w-[1064px] md:rounded-xl xl:w-[1264px]"
          ></div>
          <div className="px-3 md:px-0 xl:pr-10 md:static pt-8 pb-5 relative">
            <div className="max-w-[550px] mx-auto">
              <StructuredText
                data={{ value: secondaryContent?.value as Document, blocks: secondaryContent?.blocks }}
                customNodeRules={customNodeRules}
                renderBlock={renderBlock}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  </div>
);

export default PageHero;
